var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"title"},[_vm._v("Users Setup")])]),_c('Users-Table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }